<template>
  <div class="recipient-list card-height">
    <div class="card card-ornament">
      <h2>Recipient list</h2>
      <p>Manage your organization's list of recipients here.</p>
      <router-link :to="aboutURL" class="btn btn-outline mt-4">
        Recipient list
      </router-link> 
    </div>
  </div>
</template>

<script>
import routeNames from '../../util/routeNames';

export default {
  name: 'RecipientList',
   data() {
    return {
      aboutURL: routeNames.ADDFAMILY.PATH
    };
  }
}
</script>

<style lang="scss">
.data-management {
  .btn {
    margin: 0 auto;
  }
}

</style>
